module.exports = __webpack_public_path__ + "img/message-code.e63151bd.svg";